
import {
  Vue, Component, Prop, VModel,
} from 'vue-property-decorator';
import { InputValidationRules } from 'vuetify';
import i18n from '@/i18n';

const defaultLabel = i18n.t('labels.password');

@Component
export default class PasswordInput extends Vue {
  @Prop({ default: () => [] }) rules!: InputValidationRules;

  @VModel({ required: true }) passwordValue!: string;

  @Prop({ default: defaultLabel }).bind(this) label!: string;

  @Prop({ default: 'current-password' }) autocomplete!: string;

  @Prop({ default: 'password' }) name!: string;

  private showPass = false;
}
